import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import InfoCard from '../components/InfoCard';
import { aboutSections, differentiators, founderProfile, homeImages } from '../data/siteData';

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About BrainTorch™ Bio"
        title="Advancing science. Empowering minds."
        description="BrainTorch™ Bio is building the next generation of clinical research professionals while strengthening the ecosystem that drives innovation, improves health outcomes, and creates opportunity."
        image={homeImages.wide}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Mission & Vision"
          title="Bridging the gap between education, translational science, and employment"
          text="BrainTorch™ Bio works to expand access to careers in clinical research and healthcare while strengthening the clinical research ecosystem."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {aboutSections.map((item) => (
            <InfoCard key={item.title} title={item.title} text={item.copy} />
          ))}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="shell narrative-grid">
          {differentiators.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="narrative-block">
                <Icon size={26} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section id="founder-scientific-leadership" className="section shell founder-section">
        <div className="founder-profile">
          <div className="founder-profile__image-wrap">
            <img src={founderProfile.imageAbout || founderProfile.image} alt={founderProfile.name} className="founder-profile__image" loading="lazy" />
          </div>
          <div className="founder-profile__content">
            <p className="eyebrow">{founderProfile.role}{founderProfile.credentials ? ` · ${founderProfile.credentials}` : ''}</p>
            <h2>{founderProfile.name}</h2>
            <p className="founder-profile__role">{founderProfile.specialty}</p>
            <ul className="compact-list compact-list--inline">
              {founderProfile.quickFacts.map((fact) => (
                <li key={fact}>{fact}</li>
              ))}
            </ul>
            {founderProfile.bio.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
